import { commercialLocalInfoDomainSelector, makeNullSafeDomainGetter } from './common';

export const commercialLocalInfoSelector = makeNullSafeDomainGetter(commercialLocalInfoDomainSelector, 'commercialLocalInfo');
